export const CLINIC = [
  {
    id: 1,
    value: "Clinic 1",
  },
  {
    id: 2,
    value: "Clinic 2",
  },
  {
    id: 3,
    value: "Clinic 3",
  },

];

export const TITLE = [

  {
    id: 1,
    value: "Mr",
  },
  {
    id: 2,
    value: "Mrs",
  },

];

export const APPOINTMENT = [
  {
    id: 1,
    value: "Yes",
  },
  {
    id: 2,
    value: "No",
  },

];
export const GENDER = [
  {
    id: 1,
    value: "M",
    text: "Male",
  },
  {
    id: 2,
    value: "F",
    text: "Female",
  }, {
    id: 3,
    value: "U",
    text: "Unknown",
  }

];
export const TIMINGSLOTDURATION = [
  {
    id: 1,
    value: "1",
  },
  {
    id: 2,
    value: "5",
  },
  {
    id: 3,
    value: "15",
  },
  {
    id: 4,
    value: "20",
  },
  {
    id: 5,
    value: "30",
  },
  {
    id: 6,
    value: "40",
  },
  {
    id: 7,
    value: "60",
  },

];
